import React from 'react'
import { useNavigate,Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm, CFormInput, CFormTextarea, CInputGroup, CInputGroupText, CButton,
	CCard, CCardHeader, CCardBody, CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyButton,
	MyPagination,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'

const pjson 	= require('../../../package.json')
const Loguser 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const uDatacabangArr	= JSON.parse(localStorage.getItem("cabanglist")||"[]");

	const [uInpkeyword,setInpkeyword]	= React.useState("")
	const [uKeywordloaded,setKeywordloaded]	= React.useState("")
	const [uISTriggerreset,setTriggerreset]	= React.useState(false)
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);

	//--INIT_SELECTED_BEFORE--/
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const [uInitselectedObj,setInitselectedObj] = React.useState({});
	//--END INIT_SELECTED_BEFORE--/

	//--DLG_FORM--/
	//--END DLG_FORM--/

	//--DOM--/
	const uWindowwidth						= window.innerWidth;
	//--END DOM--/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {}
	const hdlKlikBack = () => { uNavigate(-1); }
	const hdlKDownCari = (_EV) => {
		if(_EV.keyCode !== 13) return;

		_EV.stopPropagation();
		_EV.preventDefault();

		document.getElementById("btnCari") &&
			(document.getElementById("btnCari").click());
	}
	const hdlKlikCari = () => { apiLoaddata() }
	const hdlKlikReset = async() => {
		const vNextprocess = () => { 
			setInpkeyword(""); setTriggerreset(true);
		}

		if(uKeywordloaded.trim() !== "") {
			if(await Konfirm("<b>Tampilan Akan DIRESET</b>.."+
				"<br/>Apakah Anda Yakin ?"+
				"")) vNextprocess(); 
			return;
		}

		apiLoaddata();
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentHeadersub = () => {
		if(uHtml500msg) return (
		<>
		Page 500
		<CLink onClick={()=>hdlKlikReset()} className="classcursorpointer classikon classikonreset"/>
		</>
		)//>

		const vKeyword 		= uKeywordloaded.trim();
		const vHtmlkeyword 	= (vKeyword.length < 3) ? "&#8734;" : UFunc.formatAngka(uJmlData);

		return (
		<>
		<div className="d-none d-lg-block">
		<CIcon icon="cilNewspaper" className="align-middle classikonbox" height={30}/>
		</div>

		<CForm>
			<CInputGroup
				style={{minWidth:295,width:"auto"}}
				size="sm"> 
			<CFormInput size="sm" 
				value={uInpkeyword} 
				onChange={(e) => setInpkeyword(e.target.value)} 
				onKeyDown={(e) => hdlKDownCari(e)} 
				placeholder={"--"+(uBahasaObj.petunjuk_keyword||"Masukkan uKeyword")+".."} 
				id="inpkeyword"/>
			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>hdlKlikCari()} 
				id="btnCari">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
		</CForm>

		<div className="d-none d-md-inline">
			<CTooltip className="d-none d-lg-block" content={"--"+(uBahasaObj.caption_resetdata||"Reset View Tampilan")}>
			<CLink onClick={()=>hdlKlikReset()} className="classikon classikonreset classcursorpointer" />
			</CTooltip>
				
			<span className="me-1 d-none d-lg-inline">&middot;</span>
			(<b id="idjmldata" className="text-primary">{UFunc.renderHTML(vHtmlkeyword)}</b> {uBahasaObj.word_data||"Data"})
		</div>
		</>
		)//>
	}
	const contentMain = () => {
		if(uHtml500msg) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;
		const vKeyword 		= UFunc.filterRegex(uKeywordloaded);
		const vKeywordcolor = uSettingObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		/*const vDataviewArr	= isMobile 
			? uDatamainArr.slice(0,(vMax+1)) : uDatamainArr.slice(vMin,(vMax+1));//--*/
		const vDataviewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.page||1) === parseInt(uPageActive));
		
		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={30} className="px-0"><small>No</small></th>
			<th className="px-0">
			<CRow className="mx-0">
			<CCol md="2" lg={uDatacabangArr.length > 1 ? "3" : "2"} className="px-0 text-start"><small>Tgl Login</small></CCol>
			<CCol md="2" lg={uDatacabangArr.length > 1 ? "2" : "3"} className="px-0 text-start"><small>Username</small></CCol>
			<CCol md="2" className="px-0 text-start"><small>Tgl Aktif Akhir</small></CCol>
			<CCol md="2" className="px-0 text-start"><small>Tgl Logout</small></CCol>
			<CCol md="4" lg="3" className="px-0 text-start"><small>Keterangan</small></CCol>
			</CRow>
			</th>
			</tr>

			<tr className="d-md-none classfontsmaller">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,session_id,id_user,id_cabang,nama_cabang,ip_address,
				geolocation_str,tgl_login,tgl_init,tgl_logout,
				username,nama_pengguna,
			} = vItems;

			vNumber++;
			const vGeolocationObj	= JSON.parse(geolocation_str || "{}");
			const vCaptionupper		= (nama_pengguna||"").toUpperCase();
			const vCabangcaption	= vKeyword==="" ? (nama_cabang||"Undf Cabang") 
				: (nama_cabang||"Undf").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vUsername			= vKeyword==="" ? (username||"Undf Username") 
				: (username||"Username").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vNamapengguna		= vKeyword==="" ? UFunc.Usercaptionfilter(nama_pengguna||"Undf Pengguna") 
				: UFunc.Usercaptionfilter(nama_pengguna||"Undf Pengguna").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vIPAddress		= vKeyword==="" ? (ip_address||"0.0.0.0") 
				: (ip_address||"0.0.0.0").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTgllogin			= vKeyword==="" ? UFunc.WaktuAngka(tgl_login) 
				: UFunc.WaktuAngka(tgl_login).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTglinit			= vKeyword==="" ? UFunc.WaktuAngka(tgl_init) 
				: UFunc.WaktuAngka(tgl_init).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTgllogout			= vKeyword==="" ? UFunc.WaktuAngka(tgl_logout) 
				: UFunc.WaktuAngka(tgl_logout).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");

			const vLatitude			= vGeolocationObj.latitude || "0";
			const vLongitude		= vGeolocationObj.longitude || "0";

			return (
			<tr className="align-top text-end" key={vKeys}>
			<td className="px-1">{vNumber}.</td>

			<td className="px-1 px-md-0">
				<CRow className="mx-0">
				<CCol md="2" lg={uDatacabangArr.length > 1 ? "3" : "2"} className="px-1 text-md-start classfontsmaller d-none d-md-block">
					<small>
					{UFunc.renderHTML(vTgllogin)}

					{uDatacabangArr.length > 1 && (
					<>
					<span className="mx-1 d-none d-lg-inline">&middot;</span>
					<span className="d-block d-lg-inline">{UFunc.renderHTML(vCabangcaption)}</span>
					</>
					)}
					</small>
				</CCol>

				<CCol md="2" lg={uDatacabangArr.length > 1 ? "2" : "3"} className="px-1 text-start">
					<b className="d-block text-primary text-uppercase">{UFunc.renderHTML(vUsername)}</b>
					<small className="d-none d-md-block">[{UFunc.renderHTML(vNamapengguna)}]</small>
				</CCol>

				<CCol xs="12" className="px-1 my-2 d-md-none classborderbottom"/>

				{uDatacabangArr.length > 1 && (
				<>
				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">Cabang</CCol>
				<CCol xs="8" className="px-1 d-md-none classfontsmaller">{UFunc.renderHTML(vCabangcaption)}</CCol>
				</>
				)}

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">Pengguna</CCol>
				<CCol xs="8" className="px-1 d-md-none classfontsmaller">[<b>{UFunc.renderHTML(vNamapengguna)}</b>]</CCol>

				<CCol xs="12" className="px-1 my-2 d-md-none classborderbottom"/>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">Tgl Login</CCol>
				<CCol xs="8" className="px-1 d-md-none">
					<small>{UFunc.renderHTML(vTgllogin)}</small>
				</CCol>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">Tgl Terakhir</CCol>
				<CCol xs="8" md="2" className="px-1 text-md-start">
					<small>{UFunc.renderHTML(vTglinit)}</small>
				</CCol>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">Tgl Logout</CCol>
				<CCol xs="8" md="2" className="px-1 text-md-start">
					<small>{UFunc.renderHTML(vTgllogout)}</small>
				</CCol>

				<CCol xs="12" className="px-1 my-2 d-md-none classborderbottom"/>

				<CCol md="4" lg="3" className="px-1 d-none d-md-block text-md-start classfontsmaller">
					<small className="d-none d-md-block">
					<div className="d-flex justify-content-between">
						<div>IP Address</div>
						<b>{UFunc.renderHTML(vIPAddress)}</b>
					</div>

					<div className="my-1 classborderbottom"/>

					<div className="d-flex justify-content-between">
						<div>Geo Position
						{(vGeolocationObj.latitude) && (
							<Link className="d-md-none d-lg-inline-block" to={"https://www.google.com/maps/search/?api=1&query="+
								vGeolocationObj.latitude+"%2C"+vGeolocationObj.longitude} target="_blank">
							<CIcon icon="cilExternalLink" className="ms-1 classikonbox align-middle" height={21}/>
							</Link>
						)}
						</div>

						<div style={{maxWidth:"50%"}} className="d-lg-inline-block text-end">
							{vLatitude}
							<span className="mx-1">&middot;</span>
							{vLongitude}

							{(vGeolocationObj.latitude) && (
								<Link className="d-lg-none ms-1" to={"https://www.google.com/maps/search/?api=1&query="+
									vGeolocationObj.latitude+"%2C"+vGeolocationObj.longitude} target="_blank">
								<CIcon icon="cilExternalLink" className="ms-1 classikonbox align-middle" height={21}/>
								</Link>
							)}
						</div>
					</div>
					</small>
				</CCol>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">IP Address</CCol>
				<CCol xs="8" className="px-1 d-md-none classfontsmaller">{UFunc.renderHTML(vIPAddress)}</CCol>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">Geo Location</CCol>
				<CCol xs="8" className="px-1 d-md-none classfontsmaller">
					<b>{vLatitude}<span className="mx-1">&middot;</span>{vLongitude}</b>
					{(vGeolocationObj.latitude) && (
					<>
						<span className="mx-1">&middot;</span>
					
						<Link to={"https://www.google.com/maps/search/?api=1&query="+
							vGeolocationObj.latitude+"%2C"+vGeolocationObj.longitude} target="_blank">
						<CIcon icon="cilExternalLink" className="mx-0 classikonbox align-middle" height={21}/>
						</Link>
					</>
					)}
				</CCol>
				</CRow>
			</td>
			</tr>
			)//>
		})}
		</tbody>
		</table>
		)//>
	}
	const contentDlgform = () => {}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = (_PAGE) => {
		_PAGE	= parseInt(_PAGE)||1;
		setHtml500msg();

		const vKeyword 		= uInpkeyword.trim();

		let vDatamainArr	= uDatamainArr;
		if(vKeyword.length < 3) {
			vDatamainArr 	= []
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) === 1);
			} else
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) !== uPageActive);
		}
		setLoading(true);

		//console.log("(Loguser - apiLoaddata) vKeyword",vKeyword);
		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_page: _PAGE,
			send_jmlperpage: uMaxData,
			send_loadjml: (JSON.stringify(uLastinitObj||{}) !== "{}") ? "YA" : "TIDAK",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_login/ld_logakses";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			setKeywordloaded(vKeyword);
			if(output_string.tampil) {
				//setSql((output_string.sql||"--EMPTY--"))
				const vTmpArr = JSON.parse(output_string.dataobject||"[]");
				vTmpArr.map(vItems => vItems.page = _PAGE);
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.total_data||uJmlData))
				else setJmlData(vTmpArr.length);

				setDatamainArr([...vDatamainArr,...vTmpArr]);
				//console.log("(Loguser - apiLoaddata) uPageActive : "+(uPageActive));
		    	if(JSON.stringify(uLastinitObj||{}) !== "{}") 
		    		setInitselectedObj(uLastinitObj);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Loguser - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Loguser - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
    	
		//--PAGE_LOAD_PER_PAGE--/
		if(JSON.stringify(uLastinitObj||{}) !== "{}") {
			setPageActive(uLastinitObj.initPage||1);
			apiLoaddata(uLastinitObj.initPage||1);
		}
		//--END PAGE_LOAD_PER_PAGE--/

    	return () => {
			setPageActive(0);
			uDispatch({type: "set", gInitHeaderAction: {}});
    		setInitselectedObj({});
			//setDlgviewshow(false);

    		setDatamainArr([]); 
			setJmlData(0);
			setIDselect(0);
			setRowselect(-1);
    	}
	},[])
	React.useEffect(()=>{ 
    	if(JSON.stringify(uLastinitObj||{}) !== "{}") return;
    	if(uPageActive <= 0) { setPageActive(1); return }

		const vDataviewArr	= uDatamainArr.filter(vItems=>parseInt(vItems.page||1) === parseInt(uPageActive));
		if(vDataviewArr.length > 0) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}
		apiLoaddata(uPageActive);
	},[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{ 
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
	},[uJmlData])
	React.useEffect(()=>{ 
		if(!uISTriggerreset) return;

		setTriggerreset(false);
		apiLoaddata(); 
	},[uISTriggerreset])
	//---END EFFECT--/

	//console.log("(Loguser) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0" onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto text-normal">
				<b>Log Akses User</b>
			</CHeaderBrand>

			<CHeaderNav>
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>

		<CContainer fluid className="bg-white p-2 px-3 justify-content-center justify-content-lg-between" style={{minHeight:52}}>
			{contentHeadersub()}
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-3">
		<CContainer xxl className="px-0">
			{(uHtml500msg) ? (
			<CCard className="classbgcard mb-2">
			<CCardHeader>Error Page 500</CCardHeader>
			<CCardBody className="">
				<div className="mx-3 py-lg-5">{UFunc.renderHTML(uHtml500msg)}</div>
			</CCardBody>
			</CCard>
			) : (
			<>
			<CCard className="classbgcard mb-3">
			<CCardHeader className="d-flex justify-content-between">
				<b>List Data</b>

				<div>
					<small className="d-md-none text-primary">{(()=>{
						const vKeyword 		= uKeywordloaded.trim();

						if (vKeyword.length < 3) return "";

						return (
						<>
						[{UFunc.formatAngka(uJmlData)}]
						<span className="d-md-none mx-1">&middot;</span>
						</>
						)
					})()}</small>

					<span className="classfontsmaller text-muted">
					<small>{uTimeelapse}ms</small>
					</span>
				</div>
			</CCardHeader>
			
			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
				<MyPagination 
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i)=>setPageActive(i)}
					align="start"/> 
			</CCardFooter>
			)}
			</CCard>
			</>
			)}
		</CContainer>
		</div>
		</div>
		</>
	)//>
}	

export default Loguser